import {
	IInitialFormData,
	TTypeOfEditGameDeveloperModalWindow,
} from './editDeveloperModalState/editDeveloperModalContext';
import { IUpdateGameDeveloper } from 'types';

export enum EditGameDeveloperActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: EditGameDeveloperActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditGameDeveloperActionTypes.SET_ALL_DATA;
	payload: {
		id: string;
		name: string;
	};
}

interface IChangeName {
	type: EditGameDeveloperActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetDataForSubmit {
	type: EditGameDeveloperActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateGameDeveloper | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditGameDeveloperActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditGameDeveloperModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditGameDeveloperActionTypes.RESET_FIELDS;
}

export type TEditGameDeveloperAction =
	| ISetInitialFormData
	| ISetAllData
	| IChangeName
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
